import type { PolicyDocument } from '../../types/policy';
import { company as c } from '../company';
import { freeShippingLive } from '../pricing';

export const shippingPolicy: PolicyDocument = {
  title: 'Shipping Policy',
  lead: 'How and when your MarineForceLED order arrives.',
  sections: [
    {
      id: 'regions',
      heading: 'Where we ship',
      blocks: [
        'All orders ship via USPS (United States Postal Service). We ship to addresses in all 50 U.S. states and Washington, D.C., including P.O. boxes and APO/FPO addresses. We do not currently ship internationally.',
      ],
    },
    {
      id: 'free',
      heading: 'Shipping rates',
      blocks: [
        freeShippingLive()
          ? 'Standard ground shipping is free to addresses in the contiguous United States. Expedited shipping and shipments to Alaska, Hawaii, P.O. boxes and APO/FPO addresses are charged at the rate shown at checkout.'
          : 'Shipping rates are calculated and shown at checkout before you pay. Expedited options, where offered, are charged at the rate shown at checkout.',
        'Delivery estimates shown at checkout are provided by USPS and are not guaranteed.',
      ],
    },
    {
      id: 'processing',
      heading: 'Processing time',
      blocks: [
        `Orders are processed within ${c.processingDays} after payment is confirmed, excluding weekends and U.S. holidays. During launches, promotions and peak seasons, processing may take longer. Orders flagged for fraud review may be delayed or cancelled.`,
      ],
    },
    {
      id: 'delivery',
      heading: 'Delivery estimates',
      blocks: [
        `Standard delivery typically takes ${c.deliveryEstimate} after shipment. Delivery times are estimates provided by carriers and are not guaranteed. We are not responsible for carrier delays, weather, or other events outside our control.`,
      ],
    },
    {
      id: 'tracking',
      heading: 'Tracking',
      blocks: ['You will receive a tracking number by email when your order ships. You can also use our Order Tracking page or contact support.'],
    },
    {
      id: 'address',
      heading: 'Address accuracy',
      blocks: [
        'Please check your shipping address carefully. We are not responsible for orders shipped to an incorrect or incomplete address provided at checkout. Address changes can only be made before the order ships. Packages returned to us as undeliverable will be refunded minus original and return shipping costs, or re-shipped at your expense.',
      ],
    },
    {
      id: 'risk',
      heading: 'Title and risk of loss',
      blocks: ['Title and risk of loss pass to you when your order is handed to the carrier.'],
    },
    {
      id: 'damaged',
      heading: 'Damaged or incorrect items',
      blocks: [
        `If your order arrives damaged, defective or incorrect, contact us within ${c.damageReportDays} days of delivery with your order number and clear photos of the outer box, packaging and product. Keep all packaging until the claim is resolved. We will send a replacement for verified claims at no cost to you. Claims reported after ${c.damageReportDays} days are handled under our Warranty.`,
      ],
    },
    {
      id: 'lost',
      heading: 'Lost or stolen packages',
      blocks: [
        'If tracking shows your package has not moved for 7 business days, contact us and we will open a trace with the carrier.',
        'Packages marked "delivered" by the carrier are considered delivered. We are not responsible for packages that are lost or stolen after delivery confirmation, but we will gladly help you file a claim with the carrier. Please check with neighbors, your building office and around your property before contacting us.',
      ],
    },
    {
      id: 'taxes',
      heading: 'Taxes',
      blocks: ['Sales tax is calculated at checkout based on your shipping address and applicable law.'],
    },
    {
      id: 'contact',
      heading: 'Questions',
      blocks: [`Contact ${c.supportEmail} with your order number.`],
    },
  ],
};
